/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import {
    ViewEncapsulation,
    Component,
    HostBinding,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IconService } from './icon.service';

@Component({
    selector: 'bazis-icon',
    template: `<div
        *ngIf="svgContent$ | async as svgIcon"
        [innerHTML]="svgIcon"
        class="bazis-icon-inner"
    ></div>`,
    styleUrls: ['icon.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class IconElement implements OnInit, OnChanges {
    @Input() name: string;

    @Input() src: string;

    @Input() color: string;

    @Input() size: 'xxs' | 'xs' | 's' | 'md' | 'l' | 'xl' = 'l';

    @Input() icon: string;

    @HostBinding('role') get roleElement() {
        return 'img';
    }

    @HostBinding('class') get iconStyle() {
        return {
            [`bazis-icon-${this.size}`]: !!this.size,
        };
    }

    @HostBinding('ariaHidden') get ariaHidden() {
        return true;
    }

    svgContent$: Observable<string>;

    constructor(private _service: IconService) {}

    ngOnInit(): void {
        this.svgContent$ = this._service.loadIcon$(this.getUrl());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.name || changes.src || changes.icon) {
            this.svgContent$ = this._service.loadIcon$(this.getUrl());
        }
    }

    private getUrl(): string {
        let url = this.getSrc(this.src);
        if (url) {
            return url;
        }
        url = this.getName(this.name, this.icon);
        if (url) {
            return this.getNamedUrl(url);
        }
        if (this.icon) {
            url = this.getSrc(this.icon);
            if (url) {
                return url;
            }
        }
        return null;
    }

    private getNamedUrl(iconName: string) {
        return this.getAssetPath(`icons/${iconName}.svg`);
    }

    private getName(iconName: string, icon: string): string {
        if (!iconName && icon && !this.isSrc(icon)) {
            iconName = icon;
        }
        if (this._service.isStr(iconName)) {
            iconName = iconName.toLowerCase();
        }
        if (!this._service.isStr(iconName) || iconName.trim() === '') {
            return null;
        }
        // only allow alpha characters and dash
        const invalidChars = iconName.replace(/[a-z]|-|\d/gi, '');
        if (invalidChars !== '') {
            return null;
        }
        return iconName;
    }

    private getSrc(src): string {
        if (this._service.isStr(src)) {
            src = src.trim();
            if (this.isSrc(src)) {
                return src;
            }
        }
        return null;
    }

    private isSrc(str): boolean {
        return str.length > 0 && /(\/|\.)/.test(str);
    }

    // private inheritAttributes(el, attributes = []) {
    //     const attributeObject = {};
    //     attributes.forEach((attr) => {
    //         if (el.hasAttribute(attr)) {
    //             const value = el.getAttribute(attr);
    //             if (value !== null) {
    //                 attributeObject[attr] = el.getAttribute(attr);
    //             }
    //             el.removeAttribute(attr);
    //         }
    //     });
    //     return attributeObject;
    // }

    private getAssetPath(path) {
        const assetUrl = new URL(path, `${window.location.origin}/assets/`);
        return assetUrl.origin !== window.location.origin ? assetUrl.href : assetUrl.pathname;
    }
}
